import React from 'react';
import PropTypes from 'prop-types';
import GeneralPopup, { PopupTypes } from '../../components/organisms/GeneralPopup';
import { TRANSLATION_KEY } from '../constants';
import { pendingSlackLinkShape } from '../propShapes';

const SlackLinkConfirmModal = ({ pendingLink, busy = false, onAccept, onReject }) => (
    <GeneralPopup
        open={pendingLink != null}
        type={PopupTypes.INFO_WITH_CANCEL}
        title={`${TRANSLATION_KEY}.CONFIRM_LINK.TITLE`}
        text={`${TRANSLATION_KEY}.CONFIRM_LINK.TEXT`}
        acceptText={`${TRANSLATION_KEY}.CONFIRM_LINK.ACCEPT`}
        showSpinner={busy}
        onAccept={onAccept}
        onReject={onReject}
    />
);

SlackLinkConfirmModal.propTypes = {
    pendingLink: pendingSlackLinkShape,
    busy: PropTypes.bool,
    onAccept: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
};

export default SlackLinkConfirmModal;
